import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getMain() {
        try{            
            const response = await axios.get(`Allocation`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Allocation api getMain error')
            throw error
        }
    },
    async getSummary(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Allocation/${fiscalPeriodId}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Allocation api getSummary error')
            throw error
        }
    },
    async getSummaryXls(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Allocation/xls/${fiscalPeriodId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.allocation
                }
            })           
            return response
        }catch (error){
            console.log('Allocation api getSummaryXls error')
            throw error
        }
    },
    async getByUser(fiscalPeriodId,userId,pageKey) {
        try{            
            const response = await axios.get(`Allocation/${fiscalPeriodId}/${userId}`,
            {
                headers: {
                    'page_key': pageKey
                }
            })           
            return response
        }catch (error){
            console.log('Allocation api getByUser error')
            throw error
        }
    },    
    async getHistory(fiscalPeriodId,userId) {
        try{            
            const response = await axios.get(`Allocation/history/${fiscalPeriodId}/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Allocation api getHistory error')
            throw error
        }
    },
    async getHistoryByCompany(fiscalPeriodId) {
        try{            
            const response = await axios.get(`Allocation/history/${fiscalPeriodId}`,
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Allocation api getHistoryByCompany error')
            throw error
        }
    },
    async disable(data) {
        try{            
            const response = await axios.post(`Allocation/disable`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Allocation api disable error')
            throw error
        }
    },
    async rejectDisable(data) {
        try{            
            const response = await axios.post(`Allocation/disable/reject`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Allocation api rejectDisable error')
            throw error
        }
    },
    async approveDisable(data) {
        try{            
            const response = await axios.post(`Allocation/disable/approve`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Allocation api approvedisable error')
            throw error
        }
    },
    async copy(data) {
        try{            
            const response = await axios.post(`Allocation/copy`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Allocation api copy error')
            throw error
        }
    },
    async getCompPDFByUser(fiscalPeriodId,userId) {
        try{            
            const response = await axios.get(`Allocation/pdf/${fiscalPeriodId}/${userId}`,{
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.allocation
                }
            })            
            return response
        }catch (error){
            console.log('Compensation api getCompPDFByUser error')
            throw error
        }
    },
    async getCompPDFUrlByUser(fiscalPeriodId,userId,pageKey) {
        try{            
            const response = await axios.get(`Allocation/pre-signed-url/${fiscalPeriodId}/${userId}`,{
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('Compensation api getCompPDFUrlByUser error')
            throw error
        }
    },
}